import { Middleware } from "redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { TASK_DETAIL_ACTIVITY_ID } from "../../processOverview/store/actions";
import { ProcessStepStatus } from "../../processOverview/store/constants";

/**
 * Horcht auf das Commit_Done-Event der Show_Task_Details-Aktivität, wenn der Prozess gestartet, ein Prozessschritt
 * abgeschlossen, oder der Prozess beendet wird. Es wird verhindert, dass die Overview beim Start oder dem Wechsel
 * zwischen den Prozessschritten angezeigt wird.
 */
export const preventToggleTaskDetailsMiddleware: Middleware = api => next => action => {
	if (ActivityActions.commit.done.match(action) && action.payload.params.activityId === TASK_DETAIL_ACTIVITY_ID) {
		const store = api.getState();
		const data = ActivitySelectors.data(action.payload.params.activityId)(store);

		if (
			!FormActivity.Data.SingleDocumentData.isInstance(data) ||
			data?.document.root.genehmigungsverfahren.prozessschritte.Status !== ProcessStepStatus.Completed
		) {
			return;
		}
	}
	return next(action);
};
